import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import css from "./CalculatePriceContainer.module.css";
import CalculatedResult from "../CalculatedResult/CalculatedResult";
import InputsContainer from "../Inputs/InputsContainer";
import { getCalles} from "../../Services/Services";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckRoute from '../Routes/CheckRoute';

const CalculatePriceContainer = (props) => {
  const [calles, setCalles] = useState([]);
  const [fetchOk, setFetchOk] = useState(false);

  const[result, setResult] = useState({
    
  })


  const handleSetResult = (result) => {
    setResult(result)
  }
  const fetchCalles = async () => {
    const getedCalles = await getCalles();
    if (getedCalles) {
      setCalles(getedCalles);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchCalles();
      setFetchOk(true);
    };

    fetchData();
  }, []);

  return (
    <Router>
      <Switch>
        <CheckRoute path="/result" component={CalculatedResult} result={result}>
        </CheckRoute>
        <Route path="/">
          <>
          <div className={css.backgroundImage}></div>
            
            {fetchOk ? (
              
              <InputsContainer component={CalculatedResult} calles={calles} handleSetResult={handleSetResult}></InputsContainer>
            ) : (
              <div className={css.LoadingContainer}>
                <CircularProgress />
              </div>
            )}
          </>
        </Route>
      </Switch>
    </Router>
  );
};

export default CalculatePriceContainer;
